import { TrackEventParams } from '@mitresthen/matomo-tracker-react/lib/types';
import { Box } from '@mui/material';
import { SxProps, Theme } from '@mui/material/styles';
import { useCallback } from 'react';
import { useMatomoEvent } from '../hooks/useMatomoEvent';
import { navigate } from '../hooks/useNavigate';

const sx: Record<string, SxProps<Theme>> = {
  root: ({ breakpoints }) => ({
    alignItems: 'center',
    backgroundColor: 'rgba(128,128,128,0.1)',
    borderRadius: 1,
    cursor: 'pointer',
    display: 'flex',
    flexWrap: 'wrap',
    padding: ({ spacing }) => spacing(1, 2),

    [breakpoints.down('md')]: {
      justifyContent: 'center',
      textAlign: 'center',
    },

    '&:hover': {
      backgroundColor: 'rgba(255,255,128,0.1)',
      cursor: 'pointer',
    },
  }),
  name: ({ breakpoints }) => ({
    marginTop: -0.5,
    marginBottom: -1,
    [breakpoints.up('md')]: {
      maxWidth: 520,
    },
  }),
};

const MATOMO_EVENT: TrackEventParams = {
  category: 'Click',
  action: 'VSCode extension',
};

export type PublishedBookProps = {
  name: string;
  bookUrl: string;
  coverUrl: string;
};

export function PublishedBook(props: PublishedBookProps) {
  const { name, bookUrl, coverUrl } = props;

  const triggerEvent = useMatomoEvent(MATOMO_EVENT);

  const handleClick = useCallback(() => {
    triggerEvent({ name });
    navigate(bookUrl);
  }, [bookUrl, name, triggerEvent]);

  return (
    <Box gap={1} sx={sx.root} onClick={handleClick}>
      <Box minWidth={150} sx={sx.cover}>
        <img src={coverUrl} alt="version" height="200rem" />
      </Box>

      <Box sx={sx.name}>{name}</Box>
    </Box>
  );
}
